import axios, { AxiosRequestConfig } from 'axios'

import { IItem } from '@/types/receipt'
import { ItemParams } from '@/types/item'

export const getNewItems = async (
  params: ItemParams,
): Promise<[IItem[], number]> => {
  const config: AxiosRequestConfig = {
    params,
  }
  try {
    const response = await axios.get<[IItem[], number]>('items/new', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.items.getNewItems')
  }
}

export const getReItems = async (
  params: ItemParams,
): Promise<[IItem[], number]> => {
  const config: AxiosRequestConfig = {
    params,
  }
  try {
    const response = await axios.get<[IItem[], number]>('items/re', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.items.getReItems')
  }
}

export const putItem = async (item: IItem): Promise<IItem> => {
  try {
    const response = await axios.put<IItem>(`items/${item.id}`, item)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.items.putItem')
  }
}

export const deleteItem = async (item: IItem): Promise<IItem> => {
  try {
    const response = await axios.delete<IItem>(`items/${item.id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.items.putItem')
  }
}
